export const getUpdatedAppliedGiftcards = (orderSummary, updatedAppliedGiftcards) => orderSummary.giftCardSummaries.map((giftcard) => {
  const index = updatedAppliedGiftcards.findIndex(appliedGiftcard => appliedGiftcard.cardUUID === giftcard.cardUUID);
  return {
    ...updatedAppliedGiftcards[index],
    amountApplied: giftcard.amountApplied,
    amountLeft: giftcard.amountLeft,
  };
});
